import { useUserContext } from '@/components/user-context/user-context-provider';

import { LoggedInLoom } from './logged-in/components/logged-in-loom';
import { LoggedOutLoom } from './logged-out/logged-out-loom';

export const LoomSignup = () => {
	const {
		user: { isUserLoggedIn },
	} = useUserContext();

	if (isUserLoggedIn) {
		return <LoggedInLoom />;
	}

	return <LoggedOutLoom />;
};
